import type { DrawinkFontFaceDescriptor } from "../Fonts";

import LiberationSansRegular from "./LiberationSans-Regular.woff2";

export const LiberationFontFaces: DrawinkFontFaceDescriptor[] = [
  {
    uri: LiberationSansRegular,
  },
];
